<template>
  <div
    v-show="visible"
    class="add-visite-modal"
    :class="{ isEnglish: $isEnglish }"
  >
    <div class="top clearfix">
      <h2 class="title fl">
        {{ newVisit }}
      </h2>
      <i
        class="iconfont iconicon-test5 fr close-btn"
        @click="handleCancel"
      />
      <i
        class="iconfont iconicon-test36 fr resize-btn"
        @click="handleResize"
      />
    </div>
    <!-- 新增回访 -->
    <div class="modal-body">
      <a-form
        v-if="permissionInfo.is_add_followups"
        :form="form"
      >
        <!-- 信息分级 -->
        <my-item
          v-if="configAddfields.includes('info_level') && infoLevelData && Object.keys(infoLevelData).length"
          :value="model['info_level']"
          :data="infoLevelData"
          :placeholder="$t('message[855]') + infoLevelData.fieldname"
          @change="handleChangeBaseInfo($event, 'info_level')"
        >
          <p
            v-if="recycleRuleTips"
            slot
            class="recycle-rule-tips fs-warning"
          >
            {{ recycleRuleTips }}
          </p>
        </my-item>
        <!-- 信息类型 -->
        <my-item
          v-if="configAddfields.includes('info_type') && infoStatusData && Object.keys(infoTypeData).length"
          :value="model['info_type']"
          :data="infoTypeData"
          :placeholder="$t('message[855]') + infoTypeData.fieldname"
          @change="handleChangeBaseInfo($event, 'info_type')"
        >
          <p
            v-if="recycleRuleTips"
            slot
            class="recycle-rule-tips fs-warning"
          >
            {{ recycleRuleTips }}
          </p>
        </my-item>
        <!-- 无效信息 -->
        <template v-if="invalidInfo && invalidInfo.child && invalidInfo.child.length && showInvalid">
          <my-item
            v-for="(item) in invalidInfo.child"
            :id="item.fieldkey"
            :ref="`item_${item.fieldkey}`"
            :key="item.fieldkey"
            class="clearfix"
            :data="item"
            :modules-data="invalidInfo"
            @change="handleChangeItem($event, item, 'invalid_info')"
          />
        </template>
        <!-- 跟进状态 -->
        <my-item
          v-if="configAddfields.includes('info_status') && infoStatusData && Object.keys(infoStatusData).length"
          :value="model['info_status']"
          :data="infoStatusData"
          :placeholder="$t('message[855]') + infoStatusData.fieldname"
          @change="handleChangeBaseInfo($event, 'info_status')"
        >
          <p
            v-if="recycleRuleTips"
            slot
            class="recycle-rule-tips fs-warning"
          >
            {{ recycleRuleTips }}
          </p>
        </my-item>
        <!-- 成交信息 -->
        <template v-if="dealInfo && dealInfo.child && dealInfo.child.length && showDealInfo">
          <my-item
            v-for="(item) in dealInfo.child"
            :id="item.fieldkey"
            :ref="`item_${item.fieldkey}`"
            :key="item.fieldkey"
            class="clearfix"
            :data="item"
            :modules-data="dealInfo"
            @change="handleChangeItem($event, item, 'deal_info')"
          />
        </template>
        <!-- 丢单信息 -->
        <template v-if="discardInfo && discardInfo.child && discardInfo.child.length && showDiscardInfo">
          <my-item
            v-for="(item) in discardInfo.child"
            :id="item.fieldkey"
            :ref="`item_${item.fieldkey}`"
            :key="item.fieldkey"
            class="clearfix"
            :data="item"
            :modules-data="discardInfo"
            @change="handleChangeItem($event, item, 'discard_info')"
          />
        </template>
        <!-- 回访内容 -->
        <a-form-item
          :label="`${followVisitTxt}：`"
          class="add-box"
        >
          <div
            v-decorator="['content', {
              rules: [{ required: true, message: followupTipTxt}],
              initialValue: model.content
            }]"
            class="textarea clearfix"
          >
            <a-textarea
              ref="dragBox"
              v-model="model.content"
              :placeholder="visitConPlace"
              class="fl"
              @paste="handlePaste"
            />
          </div>
        </a-form-item>
        <!-- 上传图片 -->
        <file-upload
          ref="fileUpload"
          :data="fileData"
          class="file-item"
          @change="handleChangeFile"
        />
        <!-- 回访提醒 -->
        <div
          v-if="permissionInfo.is_add_remind"
          class="others-box"
        >
          <label class="ant-form-item-label ">{{ $t('message["447"]') }}：</label>
          <!-- 设置按钮 -->
          <a
            v-if="!remindChecked"
            class="set-btn"
            @click="onChangeRemind"
          >{{ $t('message["1008"]') }}</a>
          <div
            v-if="remindChecked"
            class="remind clearfix"
          >
            <div class="time-box clearfix">
              <a-form-item
                class="fl time"
              >
                <a-date-picker
                  v-if="time"
                  v-decorator="['date', {
                    rules: [{ required: true, message: timePlace}],
                    initialValue: moment(date, 'YYYY-MM-DD')
                  }]"
                />
                <a-date-picker
                  v-else
                  v-decorator="['date', {
                    rules: [{ required: true, message: timePlace}],
                  }]"
                />
              </a-form-item>
              <a-form-item
                class="fl time"
              >
                <a-time-picker
                  v-if="time"
                  ref="timePicker"
                  v-decorator="['time', {
                    rules: [{ required: true, message: timeNeed}],
                    initialValue: moment(time, 'HH:mm')
                  }]"
                  popup-class-name="remind-time-picker"
                  format="HH:mm"
                  :open.sync="timeOpen"
                >
                  <a
                    slot="addon"
                    size="small"
                    type="primary"
                    style="margin-left: 20px;"
                    @click="handleCloseTime"
                  >
                    {{ $t('message["915"]') }}
                  </a>
                </a-time-picker>
                <a-time-picker
                  v-else
                  ref="timePicker"
                  v-decorator="['time', {
                    rules: [{ required: true, message: timeNeed}]
                  }]"
                  popup-class-name="remind-time-picker"
                  format="HH:mm"
                  :open.sync="timeOpen"
                >
                  <a
                    slot="addon"
                    size="small"
                    type="primary"
                    style="margin-left: 20px;"
                    @click="handleCloseTime"
                  >
                    {{ $t('message["915"]') }}
                  </a>
                </a-time-picker>
              </a-form-item>
              <!-- 取消设置按钮 -->
              <a
                class="clear-btn fl"
                @click="cancelSetRemind"
              >{{ $t('message["1903"]') }}</a>
            </div>
            <!-- 回访提醒内容 -->
            <a-form-item>
              <div
                v-decorator="['followup_remind_content', {
                  rules: [{ required: true, message: $t('message[447]') + $t('message[67]')}],
                  initialValue: model.followup_remind_content
                }]"
                class="remind-content"
              >
                <a-textarea
                  v-model="model.followup_remind_content"
                  class="textarea"
                  @change="handleChangeRemindContent"
                />
              </div>
            </a-form-item>
          </div>
        </div>
      </a-form>
      <div class="footer">
        <!-- 取消按钮 -->
        <a-button @click="handleCancel">
          {{ $t('message["896"]') }}
        </a-button>
        <!-- 保存按钮 -->
        <a-button
          type="primary"
          :loading="confirmLoading"
          @click="addFollowup"
        >
          {{ $t('message["21"]') }}
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { apiDomain } from '@/lib/config'
import { mapState, mapGetters, mapActions } from 'vuex'
import { getRecycleRuleTips } from '@/services/confingAutoWithdraw'
import FileUpload from '../../formItem/File'
import MyItem from '../../formItem/Item'
import moment from 'moment'
import { setCodeData, debounce } from '@/lib/utils'
import { getEncode } from '@/lib/mix'

export default {
  components: {
    FileUpload,
    MyItem
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      default: false
    },
    inquiryId: {
      type: [String, Number],
      default: () => { }
    }
  },
  provide () {
    return {
      myForm: this.form
    }
  },
  data () {
    return {
      followup: Object.assign({}, this.data), // 从详情接口获取到数据
      form: this.$form.createForm(this),
      confirmLoading: false,
      invalidInfo: {}, // 失效字段
      dealInfo: {}, // 成交字段
      discardInfo: {}, // 丢单字段
      model: { // 保存的数据
        info_type: '',
        info_status: '',
        info_level: '',
        time: '',
        followup_remind_content: '',
        content: '',
        pics: [],
        invalid_info: {},
        deal_info: {},
        discard_info: {}
      },
      showInvalid: false,
      showDealInfo: false,
      showDiscardInfo: false,
      remindChecked: false, // 回访提醒是否展示为设置
      timeOpen: false,
      changeType: 'add', // 弹窗类型，新增或编辑
      recycleParams: {}, // 获取回收提示接口的参数
      recycleRuleTips: '', // 回收提示
      pasteFiles: [] // 复制或拖拽的文件
    }
  },
  computed: {
    ...mapState('inquery/detailData', [
      'detailData'
    ]),

    ...mapGetters('inquery/detailData', ['permissionInfo']),
    from () { // all, my, audit, checkrepeat
      return this.$route.query.from
    },
    type () {
      return this.$route.query.type
    },
    checkrepeatfieldkey () {
      return this.$route.query.checkrepeatfieldkey
    },
    fileData () {
      return {
        fieldkey: 'followup',
        fieldtype: 'file',
        hideLimitText: true,
        labelname: this.$t('message["993"]'),
        isneeded: this.permissionInfo.is_pic_followup,
        accept: '*',
        fieldvalue: this.model.pics
      }
    },
    infoTypeData () {
      let data = {}
      let { base_info: baseInfo } = JSON.parse(JSON.stringify(this.detailData))
      baseInfo && baseInfo.child && baseInfo.child.forEach(item => {
        if (item.fieldkey === 'info_type') {
          data = item
          data.fieldtype = 'select'
        }
      })
      return data
    },
    infoStatusData () {
      let data = {}
      let { base_info: baseInfo } = JSON.parse(JSON.stringify(this.detailData))
      baseInfo && baseInfo.child && baseInfo.child.forEach(item => {
        if (item.fieldkey === 'info_status') {
          data = item
          data.fieldtype = 'select'
        }
      })
      return data
    },
    infoLevelData () {
      let data = {}
      let { base_info: baseInfo } = JSON.parse(JSON.stringify(this.detailData))
      baseInfo && baseInfo.child && baseInfo.child.forEach(item => {
        if (item.fieldkey === 'info_level') {
          data = item
          // data.fieldtype = 'select'
        }
      })
      return data
    },

    date () {
      let { remind } = this.followup || {}
      const { time = '' } = remind || {}
      return time.split(' ')[0] || undefined
    },
    time () {
      let { remind } = this.followup || {}
      const { time = '' } = remind || {}
      return time.split(' ')[1]
    },
    /* 回访配置附加字段，信息分级/信息类型/跟进状态 */
    configAddfields () {
      const { followup_config_addfields: configAddfields = [] } = this.followup || {}
      return configAddfields
    },
    saveTxt () {
      return this.$t('message["21"]')
    },
    followVisitTxt () {
      return this.$t('message["443"]')
    },
    followupTipTxt () {
      return this.$t('message["444"]') // 回访内容不能为空
    },
    visitConPlace () {
      return this.$t('message["777"]')
    },
    timePlace () {
      return this.$t('message["943"]')
    },
    timeNeed () {
      return this.$t('message["1070"]')
    },
    newVisit () {
      return this.$t('message["1348"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    }
  },

  watch: {
    visible (val) {
      if (val) {
        if (this.changeType === 'add') {
          if (this.configAddfields.length) {
            this.getBaseInfo()
          }
          if (this.configAddfields.includes('info_type')) {
            this.getInvalidInfo()
          }
          if (this.configAddfields.includes('info_status')) {
            this.getDealInfo()
            this.getDiscardInfo()
          }

          const { content = '', time } = this.followup.remind || {}
          this.model.followup_remind_content = content || ''
          this.model.time = time

          this.remindChecked = !!time
        }
        setTimeout(() => {
          document.body.style.overflow = 'auto'
        }, 30)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$refs.dragBox.$el.ondrop = (e) => {
        e.stopPropagation()
        e.preventDefault() // 阻止拖放后的浏览器默认行为
        const data = e.dataTransfer.items // 获取文件对象
        if (data.length < 1) {
          this.$message.error(this.$t('message["163"]'))
          return // 检测是否有文件拖拽到页面
        }
        this.resetUploadFiles(data) // 设置要上传的文件
      }
    })
  },

  methods: {
    ...mapActions('inquery/detailData', [
      'inquiryAddFollowup',
      'inquiryAddRemind'
    ]),

    moment,
    getBaseInfo () {
      let { base_info: baseInfo } = Object.assign({}, this.detailData) || {}
      baseInfo && baseInfo.child && baseInfo.child.forEach(item => {
        let { fieldvalue, fieldkey } = item || {}
        if (item.fieldkey === 'info_type') {
          this.infoTypeData.fieldvalue = fieldvalue || undefined
          this.model['info_type'] = fieldvalue || undefined
          this.toggleVisibleTypeModule(fieldvalue, this.infoTypeData)
        } else if (item.fieldkey === 'info_status') {
          this.infoStatusData.fieldvalue = fieldvalue || undefined
          this.model['info_status'] = fieldvalue || undefined
          this.toggleVisibleStatusModule(fieldvalue, this.infoStatusData)
        } else if (item.fieldkey === 'info_level') {
          this.infoLevelData.fieldvalue = fieldvalue
          this.model['info_level'] = fieldvalue
        }
        // 回收提示
        this.recycleRuleTips = ''
        this.configAddfields.forEach(key => {
          if (fieldkey === key && this.model[fieldkey]) {
            this.recycleParams[key] = this.model[fieldkey]
          }
        })
        this.getRecycleRuleTips(this.recycleParams, this)
      })
    },
    toggleVisibleStatusModule (val, data) {
      if (val === '') return
      const { options = [] } = data || {}
      const filters = options.find(item => item.id === val)
      const name = filters && filters.name
      // 是否选择成交
      this.showDealInfo = name === this.$t('message["109"]')
      // this.UPDATE_IS_DEAL(this.showDealInfo)
      // 是否选择丢单
      this.showDiscardInfo = name === this.$t('message["1690"]')
      // this.UPDATE_IS_DISCARD(this.showDiscardInfo)
    },
    toggleVisibleTypeModule (val, data) {
      if (val === '') return
      const { options = [] } = data || {}
      const filters = options.find(item => item.id === val)
      const name = filters && filters.name
      this.showInvalid = name === this.$t('message["1766"]')
      // 是否选择无效
      // this.UPDATE_IS_INVALID(this.showInvalid) // 1766: 无效
    },
    getInvalidInfo () {
      let { invalid_info: invalidInfo = {} } = JSON.parse(JSON.stringify(this.detailData))
      this.invalidInfo = invalidInfo
      if (invalidInfo.child) {
        invalidInfo.child.forEach((item = {}) => {
          const { fieldkey, fieldvalue } = item
          this.model['invalid_info'][fieldkey] = fieldvalue
        })
      }
    },
    getDealInfo () {
      let { deal_info: dealInfo = {} } = JSON.parse(JSON.stringify(this.detailData))
      this.dealInfo = dealInfo
      if (dealInfo.child) {
        dealInfo.child.forEach((item = {}) => {
          const { fieldkey, fieldvalue } = item
          this.model['deal_info'][fieldkey] = fieldvalue
        })
      }
    },
    getDiscardInfo () {
      let { discard_info: discardInfo = {} } = JSON.parse(JSON.stringify(this.detailData))
      this.discardInfo = discardInfo
      if (discardInfo.child) {
        discardInfo.child.forEach((item = {}) => {
          const { fieldkey, fieldvalue } = item
          this.model['discard_info'][fieldkey] = fieldvalue
        })
      }
    },
    handleChangeBaseInfo (val, fieldkey) {
      val = val || undefined
      if (fieldkey === 'info_type') {
        this.infoTypeData.fieldvalue = val
        this.toggleVisibleTypeModule(val, this.infoTypeData)
      } else if (fieldkey === 'info_status') {
        this.infoStatusData.fieldvalue = val
        this.toggleVisibleStatusModule(val, this.infoStatusData)
      } else if (fieldkey === 'info_level') {
        this.infoLevelData.fieldvalue = val
      }

      this.model[fieldkey] = val

      // 回收提示
      this.recycleRuleTips = ''
      this.configAddfields.forEach(key => {
        if (fieldkey === key && this.model[fieldkey]) {
          this.recycleParams[key] = this.model[fieldkey]
        }
      })
      this.getRecycleRuleTips(this.recycleParams, this)
    },
    handleChangeItem (val, item, parentKey) {
      this.model[parentKey][item.fieldkey] = val
      this.setChildInfoParams(item, parentKey)
    },
    handleChangeFile (val) {
      this.model.pics = val
    },
    onChangeRemind () {
      this.remindChecked = !this.remindChecked
      const { content = '' } = this.followup.remind || {}
      this.model.followup_remind_content = content || ''
    },
    /**
     * 滚动到错误的第一个地方
     */
    scrollIntoView (err) {
      const domId = document.getElementById(Object.keys(err)[0])
      domId.scrollIntoView()
      if (this.$refs.form) {
        let distance = this.$refs.form.scrollTop
        this.$refs.form.scrollTop = distance - 100
      }
    },
    async setChildInfoParams (item = {}, parentKey) {
      const enCode = await getEncode()
      let { fieldtype, fieldkey } = item
      let value = this.model[parentKey][fieldkey]

      const { input = '', address = '', code = {}, treedata = [] } =
            value || {}
      // 加密处理
      // text,editor,area.input,select_tree.input,tag.*,number,email.*,phone.*
      switch (fieldtype) {
        case 'text':
        case 'phone':
        case 'email':
        case 'editor':
        case 'tag':
          this.model[parentKey][fieldkey] = await setCodeData(value, enCode)
          break
        case 'area':
          this.model[parentKey][fieldkey] = this.model[parentKey][fieldkey] || {}
          if (this.$toType(code) === 'object') {
            this.model[parentKey][fieldkey].code = Object.keys(code)
          }
          this.model[parentKey][fieldkey].address = await setCodeData(address, enCode)
          break
        case 'select_tree':
          this.model[parentKey][fieldkey] = this.model[parentKey][fieldkey] || {}
          this.model[parentKey][fieldkey].treedata = treedata
          this.model[parentKey][fieldkey].input = await setCodeData(input, enCode)
          break
        case 'select_reception':
          if (!Array.isArray(value) && value === '- -') {
            this.model[parentKey][fieldkey] = []
          } else {
            this.model[parentKey][fieldkey] = value
          }
          break
        default:
          this.model[parentKey][fieldkey] = value
          break
      }
    },
    async addFollowup () {
      if (this.confirmLoading) return
      let filter = this.model.pics.filter(item => item.status === 'uploading')
      if (filter.length) {
        this.$notification.error({
          key: 'errorKey',
          message: this.$t('message["748"]'),
          description: this.$t('message["1226"]') + '...'
        })
        return
      }

      let _this = this
      this.form.validateFields(async (err, values) => {
        if (err) {
          this.scrollIntoView(err)
        } else {
          this.model.content = this.form.getFieldValue('content')

          if (_this.permissionInfo && _this.permissionInfo.is_add_remind && _this.remindChecked) {
            let date = _this.form.getFieldValue('date')
            let time = _this.form.getFieldValue('time')
            _this.model.time = moment(date).format('YYYY-MM-DD') + ' ' + moment(time).format('HH:mm')
          } else {
            this.model.time = ''
          }
          const params = {
            inquiryid: this.inquiryId,
            content: this.model.content,
            pics: this.model.pics,
            data: {
              base_info: {}
            },
            remindChecked: this.remindChecked
          }

          if (this.model.time) {
            params.followup_remind_time = this.model.time
            params.followup_remind_content = this.model['followup_remind_content']
          }
          if (this.configAddfields.includes('info_type')) {
            params.data['base_info']['info_type'] = this.model['info_type']
            params.data['invalid_info'] = this.model['invalid_info']
          }
          if (this.configAddfields.includes('info_status')) {
            params.data['base_info']['info_status'] = this.model['info_status']
            params.data['deal_info'] = this.model['deal_info']
            params.data['discard_info'] = this.model['discard_info']
          }
          if (this.configAddfields.includes('info_level')) {
            params.data['base_info']['info_level'] = this.model['info_level']
          }

          // 查重详情额外加参数
          if (this.from === 'checkrepeat' && this.checkrepeatfieldkey) {
            params.scope = this.from
            params.checkrepeatfieldkey = this.checkrepeatfieldkey
          }
          this.confirmLoading = true
          const chain = await this.inquiryAddFollowup(params)
          chain
            .params(params)
            .onNetSuccess(raw => {
              this.confirmLoading = false
              this.handleCancel()
            })
            .onSuccess(res => {
              // 如果回收提示有值，返回列表
              if (this.recycleRuleTips) {
                let timer = null
                clearTimeout(timer)
                timer = setTimeout(() => {
                  this.$router.push({
                    name: 'InqueryList',
                    query: {
                      type: this.type,
                      from: this.from
                    }
                  })
                }, 2000)
              } else {
                this.$bus.$emit('getFollowupList')
                if (this.configAddfields.length) {
                  this.$bus.$emit('fetchInquiryDetail')
                }
              }
              this.form.resetFields()
              this.model.content = ''
            })
            .fetch()
        }
      })
    },
    handleCancel () {
      this.$emit('update:visible', false)
      this.form.resetFields()
      this.model.time = ''
      this.model['followup_remind_content'] = ''
      this.model.content = ''
      this.model.pics = []
      this.model['info_type'] = undefined
      this.model['info_status'] = undefined
      this.model['info_level'] = ''

      this.fileData.fieldvalue = []
      this.pasteFiles = []
      this.infoTypeData.fieldvalue = undefined
      this.infoLevelData.fieldvalue = ''
      this.infoStatusData.fieldvalue = undefined
      this.recycleRuleTips = ''
      this.confirmLoading = false

      if (this.model.time === '') {
        this.remindChecked = false
      }

      this.$refs.fileUpload && this.$refs.fileUpload.clearFileList()
      this.changeType = 'add'
      this.$bus.$emit('changeAddReturnType', 'add')
    },
    handleResize () {
      this.$emit('update:visible', false)
      this.changeType = 'edit'
      this.$bus.$emit('changeAddReturnType', 'edit')
    },
    handleCloseTime () {
      this.timeOpen = false
    },
    async cancelSetRemind () {
      this.remindChecked = false
      if (this.model.time) {
        this.model.followup_remind_content = ''
        this.model.time = ''
      }
    },
    handleChangeRemindContent (e) {
      let val = e.target.value
      this.model.followup_remind_content = val.trim()
    },
    /**
     * 基础信息模块回收提示
      */
    getRecycleRuleTips: debounce(async (params, _this) => {
      try {
        let chain = await getRecycleRuleTips()
        chain
          .params({
            rule: params,
            inquiryid: _this.inquiryId
          })
          .onSuccess(res => {
            _this.recycleRuleTips = res
          })
          .fetch()
      } catch (error) {
        console.log(error)
      }
    }, 1000),
    // 复制事件
    handlePaste (event) {
      const items = (event.clipboardData || window.clipboardData).items

      if (!items || items.length === 0) {
        this.$message.error(this.$t('message["163"]'))
        return
      }
      // 搜索剪切板items
      this.resetUploadFiles(items)
    },
    resetUploadFiles (items) {
      let file = null
      this.pasteFiles = []
      for (let i = 0; i < items.length; i++) {
        if (/image\/jpg|image\/jpeg|image\/gif|image\/png|image\/ico|image\/bmp/.test(items[i].type)) {
          event.preventDefault()

          this.imageLoading = true
          file = items[i].getAsFile()
          if (!file) continue
          this.pasteFiles.push(file)
          file.uid = 'vc-upload-' + file.lastModified + '-' + (i + 1) * 2
          let fileObj = {
            uid: file.uid,
            name: file.name === 'image.png' ? 'image' + file.lastModified + '.png' : file.name,
            size: file.size,
            file_type: file.type,
            type: file.type,
            lastModified: file.lastModified,
            lastModifiedDate: file.lastModifiedDate,
            webkitRelativePath: file.webkitRelativePath,
            status: 'uploading'
          }
          this.model.pics.push(fileObj)
          this.pasteUpload(file)
        }
      }
      console.log(this.pasteFiles)
    },
    // 复制图片/截图上传到又拍云
    pasteUpload (file) {
      if (!file) return
      let vm = this
      this.errorCount = 0
      this.successCount = 0

      if (file.size > 1024 * 1024 * 20) { // 支持20M以内的文件上传
        this.$message.error(this.$t('message["72"]'))
        this.errorCount++
      }

      axios.post(`${apiDomain}/upload/signature`, {
        'filename': [file.name || 'pasteImg.jpg'] // 文件本地路径
      }).then(res => {
        vm.uploadFile(file, res.data.payload)
      })
    },
    // 后端参数压缩上传
    async uploadFile (file, res) {
      let vm = this
      if (!res || !res[0]) return

      // 构造FormData对象并赋值
      let formData = new FormData()
      formData.append('policy', res[0].policy) // 后端接口压缩图片参数
      formData.append('signature', res[0].signature)
      formData.append('file', file)
      vm.fileUpload(res[0], formData, file)
    },
    /*  文件上传 */
    fileUpload (result, params, file) {
      let url = result.upyunurl
      let { domain } = result
      axios.post(url || `http://v0.api.upyun.com/westartrack-file`, params, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(data => {
        if (data.data.code === 200) {
          this.successCount++
          this.model.pics.forEach(item => {
            if (item.uid === file.uid) {
              item.file_url = domain + data.data.url
              item.title = this.$t('message["1304"]') // '下载'
              item.name = item.file_name || item.name
              item.file_name = item.name
              item.file_size = item.size
              item.url = item.file_url
              item.description = item.name
              item.status = 'done'
            }
          })
        } else {
          this.errorCount++
        }
        this.fileData.fieldvalue = this.model.pics
        if (this.successCount + this.errorCount >= this.pasteFiles.length) {
          setTimeout(() => {
            if (this.errorCount) {
              this.$message.success(this.$t('message["991"]') + '，' + this.errorCount + '个文件由于过大上传失败。')
            } else {
              this.$message.success(this.$t('message["991"]'))
            }
          }, 100)
        }
      })
    }

  }
}
</script>

<style lang='scss' scoped>
.add-visite-modal {
  position: fixed;
  bottom: 16px;
  right: calc((100% - 1280px) / 2);
  top: auto;
  z-index: 99;
  width: 688px;
  padding: 56px 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  background-color: #fff;
  border-radius: 4px;
  .top {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 56px;
    line-height: 56px;
    padding: 0 20px;
    border-bottom: solid 1px #ebebeb;
    h2 {
      font-size: 18px;
      font-weight: bold;
    }
    .resize-btn {
      padding: 3px 10px 0;
      color: rgba(0, 0, 0, 0.45);
      cursor: pointer;
    }
    .close-btn {
      color: rgba(0, 0, 0, 0.45);
      cursor: pointer;
    }
  }

  .modal-body {
    width: 100%;
    max-height: 360px;
    overflow: auto;
  }
  .ant-form ::v-deep {
    padding: 32px 40px 16px;
    .ant-form-item-label {
      float: left;
      width: 100px !important;
      padding-right: 16px;
      text-align: right;
    }
    .ant-form-item-control-wrapper {
      padding-left: 100px;
    }
    .address-input {
      margin-left: 100px;
    }
    /* .ant-select {
      width: 240px;
    } */
    .recycle-rule-tips {
      max-width: 474px;
      line-height: 1.2;
      padding-top: 8px;
    }
    .add-box {
      margin-bottom: 16px;
      textarea.ant-input {
        display: block;
        width: 470px;
        height: 120px;
        margin-bottom: 0;
      }
      .placeholder {
        margin-left: 16px;
      }
    }
    .others-box {
      .set-btn {
        line-height: 32px;
      }
      .remind {
        padding-left: 100px;
        textarea {
          width: 470px;
          height: 96px;
        }
      }
      .time-box {
        margin-top: -8px;
      }
      .time {
        margin-right: 8px;
      }
      .time,
      .ant-calendar-picker,
      .ant-calendar-picker-input,
      .ant-time-picker {
        width: 160px;
      }
      .ant-form-item-control-wrapper {
        padding-left: 0;
      }
      .clear-btn {
        line-height: 32px;
      }
    }
    .file-box {
      .file-item ::v-deep {
        .ant-form-item-control-wrapper {
          padding-left: 0;
        }
        .limit-text {
          color: #f66f79;
        }
      }
    }
  }
  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 56px;
    padding: 12px 0;
    text-align: right;
    background-color: #fff;
    border-top: solid 1px #ebebeb;
  }
}
.remind-time-picker {
  .ant-time-picker-panel-addon {
    text-align: right;
  }
}
::v-deep .ql-toolbar.ql-snow .ql-formats {
  margin-right: 0;
}
::v-deep .quill-editor .ql-container.ql-snow {
  height: 100px;
}

.isEnglish {
  .ant-form ::v-deep {
    .ant-form-item-label {
      width: 140px !important;
    }
    .ant-form-item-control-wrapper {
      padding-left: 140px;
    }
    .others-box .remind {
      padding-left: 140px;
    }
    .remind .ant-checkbox-wrapper {
      float: none;
    }
  }
}
@media screen and (max-width: 1280px) {
  .add-visite-modal {
    right: 0;
  }
}
</style>
